/*************************************************/
/* HEADER                                        */
/*************************************************/
import { customCursor } from "./customCursor.js";

export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--lvl-2';
    const submenuSelector = '.menu-nav--lvl-2';
    const headerSelector = '.header';
    const parentMenuEnterEvents = ['focusin', 'mouseenter'];
    const activeClass = "active";
    let activeSubMenu = null;
    const header = document.querySelector(headerSelector);

    const init = () => {
        const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);

        if (parentMenuItems.length > 0 && header) {
            header.addEventListener('mouseleave', (event) => {
                const toElement = event.relatedTarget;

                // Check if the mouse has left the header and menu
                if (activeSubMenu && !header.contains(toElement) && !activeSubMenu.contains(toElement)) {
                    closeSubMenu(activeSubMenu);
                }
            });

            parentMenuItems.forEach(item => {
                parentMenuEnterEvents.forEach(event => {
                    item.addEventListener(event, () => {
                        const subMenu = item.querySelector(submenuSelector);
                        if (subMenu) {

                            // Close the currently active submenu (if any) before opening a new one
                            if (activeSubMenu && activeSubMenu !== subMenu) {
                                closeSubMenu(activeSubMenu);
                            }

                            openSubMenu(subMenu);
                        } else {
                            if (activeSubMenu) {
                                closeSubMenu(activeSubMenu);
                            }
                        }
                    });
                });
            });
            customCursor(".menu-nav__mega--item-link-feature");
        }
    };

    const openSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', false);
        subMenu.classList.add(activeClass);
        header.classList.add(activeClass);
        activeSubMenu = subMenu;
    };

    const closeSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', true);
        subMenu.classList.remove(activeClass);
        header.classList.remove(activeClass);
        activeSubMenu = null;
    };

    init();
}
